import { Badge } from "@/components/ui/badge";
import { UserDto } from "@exibra/shared";
import { ColumnDef } from "@tanstack/react-table";
import { t } from "i18next";

export const usersTableConfig: ColumnDef<UserDto>[] = [
    {
        id: "name",
        header: t("users.name"),
        cell: ({ row }) => row.original.name,
        size: 150,
    },
    {
        id: "email",
        header: t("users.email"),
        cell: ({ row }) => row.original.email,
        size: 200,
    },
    {
        id: "role",
        header: t("users.assignedRole"),
        cell: ({ row }) => {
            const role = row.original.tenants?.[0]?.role;
            return role ? <Badge variant="outline">{role.name}</Badge> : null;
        },
        size: 250,
    },
];
